import React, { useCallback, useRef } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { canonicalLeasesLocation } from "../../services/buildUrl.js";

function collectionSearch(search) {
  const params = new URLSearchParams(search);
  params.delete("tab");
  params.delete("peek");
  params.delete("collection");
  params.sort();
  return params.toString();
}

// External query navigation (including POP) rehydrates from its URL. Tab-only
// changes preserve in-memory band expansion; owned display replacements do not
// remount or re-fetch. The shared router is the sole history source.
export function LeasesRoute({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const boundary = useRef({ key: location.key, search: location.search, revision: 0, written: null });
  const url = location.pathname + location.search + location.hash;
  if (boundary.current.key !== location.key) {
    if (boundary.current.written !== url && collectionSearch(boundary.current.search) !== collectionSearch(location.search)) boundary.current.revision++;
    boundary.current.key = location.key;
    boundary.current.search = location.search;
    boundary.current.written = null;
  }
  const replaceDisplayUrl = useCallback((target) => {
    boundary.current.written = target;
    navigate(target, { replace: true, state: location.state });
  }, [navigate, location.state]);
  const canonical = canonicalLeasesLocation(location);
  if (canonical !== url) {
    boundary.current.written = canonical;
    return <Navigate to={canonical} state={location.state} replace />;
  }
  return children({ location, replaceDisplayUrl, revision: boundary.current.revision });
}
